import uaUtils from '../../utils/uaUtils';
import userDeviceService from './userDeviceService';

const CHROME_NAME = 'Chrome';
const MOBILE_CHROME_NAME = 'Mobile Chrome';
const MOBILE_SAFARI_NAME = 'Mobile Safari';
const ANDROID_NAME = 'Android';
const isBluefyBrowser = () => !!navigator.userAgent.match(/Bluefy/i);

const isChromeBrowser = () => {
    const browserName = uaUtils.getBrowserName();
    const {name} = uaUtils.getOS();

    return browserName === CHROME_NAME || (browserName === MOBILE_CHROME_NAME && name === ANDROID_NAME);
};

const isChromeMobileBrowser = () => {
    const browserName = uaUtils.getBrowserName();

    return browserName === MOBILE_CHROME_NAME;
};

const isMobileSafariBrowser = () => uaUtils.getBrowserName() === MOBILE_SAFARI_NAME;

const isEdgeBrowser = () => !!navigator.userAgent.match(/Edg/i);

const isEdgeAndroidBrowser = () => !!navigator.userAgent.match(/EdgA/i);

const isEdgeIOSBrowser = () => !!navigator.userAgent.match(/EdgiOS/i);

const isHuaweiBrowser = () => !!navigator.userAgent.match(/HuaweiBrowser/i);

const isBraveBrowser = () => !!navigator.brave;

const isBrowserTrusted = () => {
    const isBrowserTrusted =
        (isBluefyBrowser() || (isChromeBrowser() && !!window.chrome) || isEdgeBrowser() || isEdgeAndroidBrowser()) &&
        !isBraveBrowser();

    if (userDeviceService.isMobileDevice()) {
        // RS: Check mobile browser on extensions availability
        // to avoid some mobile browsers (Kiwi Browser)
        return isBrowserTrusted && (isEdgeAndroidBrowser() ? true : !isExtensionsAvailable()) && !isEdgeIOSBrowser();
    } else {
        return isBrowserTrusted;
    }
};

const isIOSSafariOrChrome = () =>
    userDeviceService.isIOSTouchDevice() && (isMobileSafariBrowser() || isChromeBrowser() || isChromeMobileBrowser());

const isExtensionsAvailable = () => !!window.chrome && !!window.chrome.runtime;

const getUserAgent = () => navigator.userAgent;

export default {
    getUserAgent,
    isBluefyBrowser,
    isBrowserTrusted,
    isEdgeBrowser,
    isIOSSafariOrChrome,
    isHuaweiBrowser,
};
